module.exports = __webpack_public_path__ + "static/media/03_1440.29428b07.jpeg";